import { Directive, OnDestroy } from '@angular/core';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class Disposable implements OnDestroy {
  ngOnDestroy(): void {}
}
